import script from "./tabList.vue?vue&type=script&setup=true&lang=js"
export * from "./tabList.vue?vue&type=script&setup=true&lang=js"

import "./tabList.vue?vue&type=style&index=0&id=1f50c52b&lang=css"

const __exports__ = script;

export default __exports__